import type { FourthArtOfferModel, IApiResponse } from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";
import { TagsType } from "../constants";

export const offersApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    /**
     * Получение данных по оферу 4-я книга в подарок
     */
    getFourArtOffer: build.query<FourthArtOfferModel, void>({
      query: () => ({
        url: `/foundation/api/offers/fourth-art-gift`,
      }),
      transformResponse: (response: IApiResponse<FourthArtOfferModel>) => {
        return response.payload.data;
      },
      providesTags: [{ type: TagsType.OFFER, id: "FOUR-ART-GIFT" }],
    }),
  }),
});
